import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgFormatBold = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M4.242 15h4.423q1.338 0 2.31-.488a3.5 3.5 0 0 0 1.495-1.375q.53-.898.53-2.108 0-.956-.382-1.697a3.07 3.07 0 0 0-2.598-1.708v-.078q.704-.117 1.242-.546.54-.43.843-1.073.304-.653.304-1.425 0-1.073-.469-1.853a3.13 3.13 0 0 0-1.33-1.22Q9.75 1 8.57 1H4.241q-.59 0-.92.38Q3 1.752 3 2.434v11.142q0 .673.321 1.053.33.37.921.371m1.208-2.02V8.737h2.433q1.277 0 1.955.536.677.538.677 1.57 0 1.035-.66 1.591-.651.547-1.877.547zm0-6.078V3.05h2.424q1 0 1.555.488.565.487.565 1.375 0 .937-.634 1.464-.625.526-1.755.526z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFormatBold);
export default ForwardRef;
